<template>
  <div class="bg-primary-light">
    <p class="text-18 fw-medium text-center">Testez le produit en cliquant ci-dessous, ou contactez nous <br>pour toutes demandes d’information</p>
    <div class="d-flex justify-content-center pt-3">
      <a class="btn btn-outline-primary btn me-4" href="mailto:postmaster@naega.fr">Contacter Naega</a>
      <a class="btn btn-primary btn" href=".">Utiliser Naega DI</a>
    </div>
  </div>
  <footer>
    <div class="container-fluid d-flex">
      <div class="mt-4 ms-5 mb-2">
        <a href="../" title="Accueil">
          <img src="../assets/LOGO_NAEGA_DI_white.svg" alt="logo naega DI">
        </a>
        <p class="ms-4 mt-2">Naega DI 2021, un outil de Naega, tous droits reservés</p>
      </div>
      <nav class="nav me-5">
        <a class="nav-link" href="#">CGV</a>
        <a class="nav-link" href="../cgu">CGU</a>
        <a class="nav-link" href="#">Politique de confidentialité</a>
        <a class="nav-link" href="#">Cookies</a>
      </nav>
    </div>
  </footer>
</template>
<script>
export default {
  name: 'PageFooter'
}
</script>
